module.exports = __webpack_public_path__ + "img/teasers_4.1e03b044.jpg";